import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import type {
    VipTierProgressResponse,
    VipTiersResponse,
} from "../entities/RewardsVipTiersEntities";
import {
    VipTierProgressResponseSchema,
    VipTiersResponseSchema,
} from "../entities/RewardsVipTiersSchemas";
import type { VipTiersQueryParams } from "../types";

@singleton()
class RewardsVipTiersApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public getTiers(
        queryParams: VipTiersQueryParams
    ): Observable<VipTiersResponse> {
        return this.apiClient
            .get({
                url: "/tiers/getTiers",
                queryParams,
                responseType: "json",
            })
            .pipe(
                map((response) => create(response.body, VipTiersResponseSchema))
            );
    }

    public getTierProgress(): Observable<VipTierProgressResponse> {
        return this.apiClient
            .get({
                url: "/tiers/getTierProgress",
                responseType: "json",
            })
            .pipe(
                map((response) =>
                    create(response.body, VipTierProgressResponseSchema)
                )
            );
    }
}

export default RewardsVipTiersApiService;
